import { defineComponent, IOmniaShell, selectMany } from "../../omnia"
import { SatelliteApi } from "../api"
import { SatelliteContext } from "../context"
import { createState, getFieldBoundariesStatus, Group, GroupItem, setSelectedFields, State, toggleField, toggleGroup } from "./state"

export class BoundariesCtrl {

    static create(): ng.IDirective {
        return defineComponent(BoundariesCtrl, "app/datalayers/satellite/boundaries/boundaries.html", {
            context: "="
        })
    }

    context: SatelliteContext

    private api: SatelliteApi
    private state: State

    public groups: Group[]

    static $inject = ["$scope", "OmniaShell"]

    constructor($scope: ng.IScope, private readonly shell: IOmniaShell) {
    }

    $onInit() {

        const { api } = this.context

        this.api = api

        const state = createState(api)

        const selectable = new Set(
            selectMany(state.groups.map(g => g.items.map(i => i.fieldId)))
        )

        this.context.map.enableSelection(
            false,
            f => selectable.has(f.fieldId),
            fields => this.setState(setSelectedFields(this.state, fields))
        )


        this.setState(state)

    }

    setState(state: State) {
        const { groups, fields, selection } = state
        this.state = state
        this.groups = groups
        const selectedFields = fields.filter(f => selection.has(f.fieldId))
        this.context.map.setSelection(selectedFields)
    }


    toggleField(group: Group, field: GroupItem) {
        this.setState(toggleField(this.state, group, field))
    }

    toggleGroup(group: Group) {
        this.setState(toggleGroup(this.state, group))
    }

    cancel() {
        this.context.close(false)
    }

    commit() {

        const all = getFieldBoundariesStatus(this.state)

        this.api.setupFieldBoundaries(all).then(() => {

            this.context.close(true)

            omnia.shell.showInfo(
                this.shell,
                "<p>Your request has been recorded. Imagery for the selected fields will be downloaded in the background, and will be available in up to 24 hours from now.</p>",
                "Imagery"
            )

        })
    }
}
